<template lang='pug'>
  b-modal(
    :visible="show",
    @hidden='handleModalHidden')
    template(#modal-header)
      span.title {{$t('config')}}
    b-tabs(card)
      b-tab(:class= "{'padding-custom': !pk, 'card_body': true}" :title="`${$t('setting')}`" active)
        b-container(fluid)
          b-card.w-100.mb-3(no-body)
            b-list-group(flush)
              b-list-group-item
                b-row
                  b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('config-name')}}
                  b-col(cols="12" sm="9")
                    b-form-input(v-model="configInfo.config_name")
          b-card.w-100.mb-3(no-body)
            b-list-group(flush)
              b-list-group-item
                b-row
                  b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('config-desc')}}
                  b-col(cols="12" sm="9")
                    b-form-textarea(v-model="configInfo.config_desc")
          b-card.w-100.mb-3(no-body)
            b-list-group(flush)
              b-list-group-item
                b-row
                  b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('info_update_interval')}}
                  b-col(cols="12" sm="9")
                    div.update-time.align-items-center
                      b-form-input.mr-3(v-model="configInfo.info_update_interval" style="width: 62px")
                      span {{$t('second')}}
          b-card.w-100.mb-3(no-body)
            b-list-group(flush)
              b-list-group-item
                b-row
                  b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('location-tracking')}}
                  b-col(cols="12" sm="9")
                    b-form-checkbox(v-model="configInfo.flag_location") {{$t('location-tracking')}}
          b-card.w-100.mb-3(no-body)
            b-list-group(flush)
              b-list-group-item
                b-row
                  b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('enter-pin')}}
                  b-col(cols="12" sm="9")
                    b-form-checkbox(v-model="configInfo.flag_pin") {{$t('pin_flag')}}
          b-card.w-100(no-body)
            b-list-group(flush)
              b-list-group-item
                b-row
                  b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('scheduling-updates')}}
                  b-col(cols="12" sm="9")
                    div.update-time.mb-1
                      b-form-checkbox(v-model="configInfo.flag_config_update") {{$t('update-time')}} :
                      div.d-flex.flex-wrap
                        b-input-group-append.d-flex.align-items-center.mb-2
                          b-select.ml-2.h-100(v-model="startHour" :options="hourOptions" size="sm")
                          span.ml-1 {{$t('hour')}}
                          b-select.ml-2.h-100(v-model="startMinute" :options="minOptions" size="sm")
                          span.ml-1.mr-2 {{$t('minute')}}
                        span.mr-2 -
                        b-input-group-append.d-flex.align-items-center.mb-2
                          b-select.ml-2.h-100(v-model="endHour" :options="hourOptions" size="sm")
                          span.ml-1 {{$t('hour')}}
                          b-select.ml-2.h-100(v-model="endMinute" :options="minOptions" size="sm")
                          span.ml-1 {{$t('minute')}}
                    span ({{$t('update-time-desc')}})
          
      b-tab(v-if='this.pk' :title="$t('applications.title')")
        b-container(fluid)
          b-card.table-card
            b-table(
              ref="applicationTableBody",
              :fields="tableData.fields",
              :items="fetchApplicationList",
              :current-page="tableData.pagination.current",
              :per-page="tableData.pagination.limit",
              :class="tableClass",
              :empty-text="$t('no-content')",
              tbody-class="lmm-table-body",
              sort-by="package_id",
              :sort-desc="true",
              show-empty
              responsive
            )
              template(#cell(action)='row')
                div.nowrap
                  b-button-group
                    b-dropdown(dropleft size="sm", variant="white" :text="actionName(row.item)" @show="openDropDown" @hidden="closeDropDown")
                      b-dropdown-item(v-if="row.item.app_action !== '-'" @click="handleInstallState(row.item.pk, 0)")
                        span {{$t('not-installed')}}
                      b-dropdown-item(@click="handleInstallState(row.item.pk, 1)")
                        span {{$t('installed')}}
                      b-dropdown-item(v-if="row.item.app_action !== '-'" @click="handleInstallState(row.item.pk, 2)")
                        span {{$t('delete')}}
          
          .pagination-wrap
            div
              b-form-select(
                size="sm",
                v-model="tableData.pagination.limit",
                :options="tableData.pagination.perOptions")
            b-pagination(
              size="sm",
              v-model="tableData.pagination.current",
              :total-rows="tableData.pagination.total",
              :per-page="tableData.pagination.limit",
              class="my-0 float-right"
            )
    
    template(#modal-footer)
      b-btn(v-if='isAddMode' variant="primary",  @click="handleSave") {{$t('confirm')}}
      b-btn(v-else variant="primary",  @click="handleEdit") {{$t('confirm')}}
      b-btn(@click="closeDialog") {{$t('cancel')}}
</template>

<script>
import { ApplicationsAPI } from '@/api'
import AppConfigsAPI from '@/api/app-configs'
import _ from 'lodash'

export default {
  name: 'DialogAppConfig',
  props: {
    show: Boolean,
    pk: {
      type: Number,
      default: null,
    },
    isAddMode: Boolean,
  },
  data() {
    return {
      tableClass: '',
      isClosed: false,
      installationState: '',
      changes: [],
      configInfo: {
        config_name: '',
        config_desc: '',
        flag_location: false,
        flag_pin: false,
        flag_config_update: false,
        config_update_time: '',
        config_start_update_time: '',
        config_end_update_time: '',
        info_update_interval: 300,
      },
      startHour: '',
      startMinute: '',
      endHour: '',
      endMinute: '',
      tableData: {
        fields: [
          {key: 'app_name', label: this.$t('app_name'), sortable: true, thStyle: {minWidth: '120px', width: '400px'}},
          {key: 'app_version', label: this.$t('app_version'), sortable: true, thStyle: {minWidth: '120px'}},
          {key: 'action', label: this.$t('action'), sortable: false, thStyle: {minWidth: '100px', width: '150px'}},
        ],
        pagination: {
          by: 'create_time',
          limit: 5,
          offset: 0,
          order: 'desc',
          
          search_key: '',
          search_value: '',
          search_mode: 'pagination',
          
          total: 1,
          current: 1,
          perOptions: [
            {value: 5, text: '5'},
            {value: 10, text: '10'},
          ],
        },
      },
    }
  },
  computed: {
    hourOptions() {
      return _.range(0, 24).map(item => {
        const num = item < 10 ? '0' + item : item
        return {text: num, value: num}
      })
    },
    minOptions() {
      return _.range(0, 60).map(item => {
        const num = item < 10 ? '0' + item : item
        return {text: num, value: num}
      })
    },
  },
  mounted() {
    this.fetchAppConfigInfo()
  },
  methods: {
    // 세부 정보 확인 시 구성 정보를 가져오는 메서드
    async fetchAppConfigInfo(pk) {
      if (pk !== null && pk !== undefined) {
        let res = await AppConfigsAPI.get(`${pk}`)
        let resData = res.data.objects
        this.configInfo.config_name = resData.config_name
        this.configInfo.config_desc = resData.config_desc
        this.configInfo.flag_location = resData.flag_location
        this.configInfo.flag_pin = resData.flag_pin
        this.configInfo.flag_config_update = resData.flag_config_update
        this.configInfo.config_update_time = resData.config_update_time
        this.configInfo.config_start_update_time = resData.config_start_update_time
        this.configInfo.config_end_update_time = resData.config_end_update_time
        this.configInfo.info_update_interval = resData.info_update_interval
      }
      this.initializeTime()
    },
    // 세부 정보 확인 시 애플리케이션 정보를 가져오는 메서드
    fetchApplicationList(ctx) {
      if (ctx.sortBy === '') {
        return
      }
      
      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? 'desc' : 'asc'
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit
      
      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,
        
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: 'pagination',
      }
      return ApplicationsAPI.get(`applications_with_config/${this.pk}`, {params})
          .then(res => {
            const {objects, meta, status} = res.data
            
            if (status !== 200) {
              this.$awn.warning(this.$t('data_get_fail'))
              return []
            }
            
            this.tableData.list = objects
            this.tableData.pagination.total = meta.total_count
            
            return this.tableData.list
          })
    },
    // 구성 추가 및 수정 시 업데이트 시간 관련 메서드
    initializeTime() {
      if (this.configInfo.config_start_update_time && this.configInfo.config_end_update_time) {
        const [startHour, startMinute] = this.configInfo.config_start_update_time.split(':')
        const [endHour, endMinute] = this.configInfo.config_end_update_time.split(':')
        this.startHour = startHour
        this.startMinute = startMinute
        this.endHour = endHour
        this.endMinute = endMinute
        
      } else {
        // 기본값
        this.startHour = '00'
        this.startMinute = '00'
        this.endHour = '05'
        this.endMinute = '59'
      }
    },
    // 백엔드의 형태에 맞게 업데이트 시간을 파싱하는 메서드
    updateConfigTime() {
      const startTime = parseInt(this.startHour) * 60 + parseInt(this.startMinute)
      const endTime = parseInt(this.endHour) * 60 + parseInt(this.endMinute)
      const timeDifference = endTime - startTime
      
      if (endTime <= startTime || timeDifference <= 180) {
        this.AppState.$emit('show-message-dialog', {context: {path: 'update_schedule_error'}})
        return false
      }
      
      this.configInfo.config_update_time = `${this.startHour}:${this.startMinute}-${this.endHour}:${this.endMinute}`
      return true
    },
    handleModalHidden() {
      this.closeDialog()
      this.isClosed = false
    },
    closeDialog() {
      if (this.isClosed) {
        return
      }
      this.isClosed = true
      this.configInfo = {
        config_name: '',
        config_desc: '',
        flag_location: false,
        flag_pin: false,
        flag_config_update: false,
        config_update_time: '',
        info_update_interval: 300,
      }
      // 초기화
      this.startHour = '00'
      this.startMinute = '00'
      this.endHour = '05'
      this.endMinute = '59'
      this.$emit('close')
    },
    async handleSave() {
      if (!this.updateConfigTime()) {
        return
      }
      let params = {
        config_name: this.configInfo.config_name,
        config_desc: this.configInfo.config_desc,
        flag_location: this.configInfo.flag_location,
        flag_pin: this.configInfo.flag_pin,
        flag_config_update: this.configInfo.flag_config_update,
        config_update_time: this.configInfo.config_update_time,
        info_update_interval: this.configInfo.info_update_interval,
      }
      try {
        const res = await AppConfigsAPI.post('', params)
        if (res.data.objects && res.data.objects.error) {
          throw new Error(res.data.objects.error)
        } else {
          this.$awn.success(this.$t('app_config_add_success'))
          this.closeDialog()
        }
      } catch (error) {
        console.error(this.$t('application_add_error'), error)
        this.$awn.warning(error.message)
        this.closeDialog()
      }
    },
    async handleEdit() {
      if (!this.updateConfigTime()) {
        return
      }
      
      let params = {
        config_name: this.configInfo.config_name,
        config_desc: this.configInfo.config_desc,
        flag_location: this.configInfo.flag_location,
        flag_pin: this.configInfo.flag_pin,
        flag_config_update: this.configInfo.flag_config_update,
        config_update_time: this.configInfo.config_update_time,
        info_update_interval: this.configInfo.info_update_interval,
      }
      
      try {
        const res = await AppConfigsAPI.put(`${this.pk}`, params)
        if (res.data.objects && res.data.objects.error) {
          throw new Error(res.data.objects.error)
        }
        
        for (let change of this.changes) {
          let actionParams = {
            'app_config_fk': this.pk,
            'application_fk': change.applicationPk,
            'app_action': change.state,
          }
          
          if (change.state === 1) {
            await AppConfigsAPI.post(`app_config_application_relation`, actionParams)
          } else {
            await AppConfigsAPI.put(`app_config_application_relation`, actionParams)
          }
        }
        
        this.$awn.success(this.$t('app_config_info_updated'))
        this.closeDialog()
      } catch (error) {
        console.error(this.$t('application_add_error'), error)
        this.$awn.warning(error.message)
        this.closeDialog()
      }
    },
    openDropDown() {
      this.tableClass = 'show-dropdown'
    },
    closeDropDown() {
      this.tableClass = ''
    },
    handleInstallState(applicationPk, state) {
      // state : 1: 설치, 0: 설치안함, 2: 설치삭제
      const existingChange = this.changes.find(change => change.applicationPk === applicationPk)
      
      if (existingChange) {
        existingChange.state = state
      } else {
        this.changes.push({applicationPk, state})
      }
      const item = this.tableData.list.find(item => item.pk === applicationPk)
      if (item) {
        item.app_action = state
      }
    },
    actionName(item) {
      let result = item.app_action
      switch (item.app_action) {
        case 1:
          result = this.$t('installed')
          break
        case 0:
          result = this.$t('not-installed')
          break
        case 2:
          result = this.$t('delete')
          break
        default:
          result = this.$t('not-installed')
      }
      
      return result
    },
  },
  watch: {
    pk(newVal) {
      if (newVal !== null) {
        this.fetchAppConfigInfo(newVal)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  font-size: 20px;
  font-weight: 500;
  color: #f0f0f0;
  line-height: 100%;
  letter-spacing: -.5px;
}

::v-deep .modal-dialog {
  max-width: 1000px;
}

.col-3 {
  display: flex;
  align-items: center;
}

.update-time {
  display: flex;
  
  span {
    white-space: nowrap;
  }
}

.padding-custom {
  padding: 1.25rem 1.25rem 0 1.25rem;
}

@media (max-width: 768px) {
  .card-body {
    padding: 10px 0 0 0;
  }
  
  .container-fluid {
    padding: 0;
  }
}
</style>